import { Badge, badgeClassName } from '@/core/lib/new-architecture/store/badges.store';
import BadgeCard from '@/core/pages/profile/PublicProfile/Status/BadgeCard';

export type CatType = keyof typeof badgeClassName;

const BadgesTab: React.FC<{ badges: Badge[]; cat: CatType; userValue?: number; hasProgressBarOnCard?: boolean }> = ({ badges, cat, userValue, hasProgressBarOnCard }) => {
  const checkedClassName = badgeClassName[cat];

  return (
    <div className="mt-6 grid grid-cols-2 gap-3 text-center lg:grid-cols-3">
      {badges.map(badge => (
        <BadgeCard key={badge.alias} badge={badge} checkedClassName={checkedClassName} userValue={userValue} hasProgressBarOnCard={hasProgressBarOnCard} />
      ))}
    </div>
  );
};

export default BadgesTab;
